export default {
  'component.agenttimeline.title': 'Tidslinjer',
  'component.agenttimeline.description': 'Her finner du tidslinjene til selger og kjøper',
  'component.agenttimeline.sellerstimeline': 'Selgers Tidslinje',
  'component.agenttimeline.buyerstimeline': 'Kjøpere Tidslinje',
  'component.agenttimeline': 'Tidslinje',
};
